// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"19375baf","977":"e13d768a"}[chunkId] + ".chunk.js";
};